import { toast } from "react-toastify";
import { printHtmlDocument } from "./printTable";

// Fetches a report from the backend as markup and prints it.
//
// The obvious approach - print the report PDF in a hidden iframe - is not
// dependable: Safari cannot print a PDF that lives in a frame and silently
// prints the surrounding dashboard instead, which is how a print ends up with
// no logo and no table borders. Asking the backend for the same report as HTML
// (output=html) keeps the blade markup and CSS the PDF uses, with the logo
// inlined, and the browser prints markup it fully controls.
export async function printReportUrl(url, options) {
    try {
        const res = await fetch(url, options);
        const text = await res.text();

        if (!res.ok || text.trim().charAt(0) === "{") {
            // "No records found" and friends come back as JSON - show the
            // backend's own message instead of a generic failure.
            let message = "This report cannot be printed. Please use Download PDF.";
            try {
                const body = JSON.parse(text);
                if (body && body.message) {
                    message = body.message;
                }
            } catch (parseErr) {
                // Not JSON - keep the default message.
            }
            toast.error(message);
            return;
        }

        printHtmlDocument(text);
    } catch (err) {
        toast.error("Unable to print the report. Please use Download PDF.");
    }
}

// Kept for reports built client-side with jsPDF.
export { printElement, printDataTable } from "./printTable";

// Shared entry point for the report buttons: 'print' asks for the print
// rendering of the same report, anything else keeps the existing download.
export function deliverReport(url, dtype, options) {
    if (dtype === "print") {
        const printUrl = url.replace(/([?&](?:type|format)=)print(?=&|$)/, "$1pdf");
        // print=1 merges the per-group / per-member sections into one document
        // instead of a zip; output=html returns it as printable markup.
        const separator = printUrl.indexOf("?") === -1 ? "?" : "&";

        return printReportUrl(printUrl + separator + "print=1&output=html", options);
    }
    window.open(url, "_blank");
}

export default deliverReport;
